<template>
  <section class="quote-info">
    <template  v-if="isEndorsement">
      <div
        v-for="(item,index) in compareData"
        :key="index"
        class="box">
        <h3 v-if="!item.isBold&&item.title">{{ item.title }}</h3>
        <h2 v-if="item.isBold&&item.title">{{ item.title }}</h2>
        <span
          v-if="item.secondTile"
          class="title bold">{{ item.secondTile }}</span>
        <table
          class="table"
          :class="item.class">
          <template>
            <tr
              v-for="(sumItem,sumIndex) in item.list"
              v-show="!sumItem.notShow"
              :key="sumIndex"
              class="tr oll">
              <td>{{ sumItem.name }}</td>
              <template  v-if="sumItem.type == 'value'">
                <td v-if="formData[sumItem.field] === oldForm[sumItem.field]">
                  {{ sumItem.value }}
                </td>
                <td
                  v-else
                  class="compare">
                  <span
                    class="text-line color-danger">
                    {{ sumItem.oldValue }}
                  </span>

                  <span
                    class="color-success"
                  >
                    {{ sumItem.value }}
                  </span >

                </td>
              </template>
              <template  v-else-if="sumItem.type == 'array'">
                <td v-if="formData[sumItem.field] === oldForm[sumItem.field]">
                  {{ sumItem.value }}
                </td>
                <td
                  v-else
                  class="compare">
                  <span
                    class="text-line color-danger">
                    {{ sumItem.oldValue }}
                  </span>

                  <span
                    class="color-success"
                  >
                    {{ sumItem.value }}
                  </span >

                </td>
              </template>
              <template  v-else>
                <td v-if="formData[sumItem.field] === oldForm[sumItem.field]">
                  {{ showCompare(sumItem, formData[sumItem.field]) }}
                </td>
                <td
                  v-else
                  class="compare">
                  <span
                    class="text-line color-danger">
                    {{ showCompare(sumItem, oldForm[sumItem.field]) }}
                  </span>

                  <span
                    class="color-success"
                  >
                    {{ showCompare(sumItem, formData[sumItem.field]) }}
                  </span >

                </td>
              </template>
            </tr>
          </template>
        </table>
      </div>
    </template>
    <template v-else>
      <div
        v-for="(item,index) in compareData"
        :key="index"
        class="box"
        :class="item.boxClass" >
        <h3 v-if="!item.isBold&&item.title">{{ item.title }}</h3>
        <h2 v-if="item.isBold&&item.title">{{ item.title }}</h2>
        <span
          v-if="item.secondTile"
          class="title bold">{{ item.secondTile }}</span>
        <table
          class="table"
          :class="item.class">
          <template >
            <tr
              v-for="(sumItem,sumIndex) in item.list"
              v-show="!sumItem.notShow"
              :key="sumIndex"
              class="tr">
              <td>{{ sumItem.name }}</td>

              <td
                v-if="sumItem.type == 'value'&&!sumItem.option"
                v-copy="sumItem.value"
                :class="{'green-tip':handleCompare(sumItem.field)}">
                {{ sumItem.value }}
              </td>
              <td
                v-else-if="sumItem.type == 'value'&&sumItem.option"
                v-copy="getName(sumItem.value)"
                :class="{'green-tip':handleCompare(sumItem.field)}">
                {{ getName(sumItem.value) }}
              </td>
              <td
                v-else-if="sumItem.type == 'file'"
                v-copy="sumItem.value&&sumItem.value.client_name"
                class="blue pointer"
                :class="{'green-tip':handleCompare(sumItem.field)}"
                @click="openFile(sumItem.value.url)">
                {{ sumItem.value&&sumItem.value.client_name }}
              </td>
              <td
                v-else-if="sumItem.type == 'array'"
                :class="{'green-tip':handleCompare(sumItem.field)}"
              >
                <span
                  v-for="(sum,index) in sumItem.value"
                  :key="'sum'+index"
                  v-copy="sum.name">{{sum.name}}<br></span>
              </td>
              <td
                v-else
                v-copy="showCompare(sumItem, formData[sumItem.field],sumItem.field)"
                :class="{'green-tip':handleCompare(sumItem.field)}">
                {{ showCompare(sumItem, formData[sumItem.field],sumItem.field) }}
                <email-tooltip
                  v-if="sumItem.field === 'email'"
                  :email="formData.email"></email-tooltip>
              </td>
            </tr>
          </template>
        </table>
      </div>
    </template>

    <div class="box">
      <h2>Traveller Details</h2>
      <table
        v-for="(item,index) in nm_traveler_list"
        :key="index"
        class="table">
        <tr class="tr th">
          <th>Traveller {{index+1}}</th>
        </tr>
        <tr class="tr">
          <td>Title</td>
          <!--          <span  :class="{'green-tip':compareChange(index,'title')}">{{ getOptionName('titleOptions', item.title) }}</span>-->
          <td
            v-if="!compareChange(index,'title')"
            v-copy="getOptionName('titleOptions', item.title)"
          >
            {{ getOptionName('titleOptions', item.title) }}
          </td>
          <td
            v-else
            class="compare">
            <span
              class="text-line color-danger">
              {{ getOptionName('titleOptions', oldTravle(index,'title')) }}
            </span>

            <span
              class="color-success">
              {{ getOptionName('titleOptions', item.title)}}
            </span >
          </td>

        </tr>
        <tr class="tr">
          <td>Last Name</td>
          <!--          <span :class="{'green-tip':compareChange(index,'lst_nm')}">{{ item.lst_nm }}</span>-->
          <td
            v-if="!compareChange(index,'lst_nm')"
            v-copy="item.lst_nm"
          >
            {{ item.lst_nm}}
          </td>
          <td
            v-else
            class="compare">
            <span
              class="text-line color-danger">
              {{ oldTravle(index,'lst_nm') }}
            </span>

            <span
              class="color-success">
              {{ item.lst_nm}}
            </span >
          </td>
        </tr>
        <tr class="tr">
          <td>First Name</td>
          <!--          <span :class="{'green-tip':compareChange(index,'fst_nm')}">{{ item.fst_nm }}</span>-->
          <td
            v-if="!compareChange(index,'fst_nm')"
            v-copy="item.fst_nm"
          >
            {{ item.fst_nm}}
          </td>
          <td
            v-else
            class="compare">
            <span
              class="text-line color-danger">
              {{ oldTravle(index,'fst_nm') }}
            </span>

            <span
              class="color-success">
              {{ item.fst_nm}}
            </span >
          </td>
        </tr>
        <tr class="tr">
          <td>{{item.id_type==1?'HKID':'Passport'}}</td>
          <!--          <span  :class="{'green-tip':compareChange(index,'id_no')}">{{ item.id_no }}</span>-->
          <td
            v-if="!compareChange(index,'id_no')"
            v-copy="item.id_no"
          >
            {{ item.id_no}}
          </td>
          <td
            v-else
            class="compare">
            <span
              class="text-line color-danger">
              {{ oldTravle(index,'id_no') }}
            </span>

            <span
              class="color-success">
              {{ item.id_no}}
            </span >
          </td>
        </tr>
        <tr
          v-if="item.id_type==2"
          class="tr">
          <td>Nationality</td>
          <td>{{getOptionName('nationalityOptions',item.id_nationality_seq)}}</td>
        </tr>
        <tr class="tr">
          <td>Date of Birth</td>
          <!--          <span  :class="{'green-tip':compareChange(index,'dob_date')}">{{ item.dob }}</span>-->
          <td
            v-if="!compareChange(index,'dob')"
            v-copy="showHKDate(item.dob)"
          >
            {{ showHKDate(item.dob)}}
          </td>
          <td
            v-else
            class="compare">
            <span
              class="text-line color-danger">
              {{ showHKDate(oldTravle(index,'dob')) }}
            </span>

            <span
              class="color-success">
              {{ showHKDate(item.dob)}}
            </span >
          </td>
        </tr>
        <tr class="tr">
          <td>Relationship</td>
          <td
            v-copy="getAllOptionName23('relation',item.rel)"
            :class="{'green-tip':compareChange(index,'rel')}">{{ getAllOptionName23('relation',item.rel) }}</td>
        </tr>
        <template v-if="!!item.guardian_nm&&!!item.guardian_phone">
          <tr class="tr th">
            <th>Parents or Legal Guardian</th>
          </tr>
          <tr class="tr">
            <td>Name</td>
            <td  :class="{'green-tip':compareChange(index,'guardian_nm')}">{{ item.guardian_nm }}</td>
          </tr>
          <tr class="tr">
            <td>Contact Number</td>
            <td  :class="{'green-tip':compareChange(index,'guardian_phone')}">{{ item.guardian_phone }}</td>
          </tr>
        </template>
      </table>
    </div>


  </section>
</template>
<script>
import dayjs from 'dayjs'
import MixinOptions from '@/mixins/options'

export default {
  name: 'TravelQuoteInfo',
  mixins: [MixinOptions],
  props: {
    formData: {
      type: Object,
      default: () => ({})
    },
    preFormData: {
      type: Object,
      default: () => ({})
    },
    compareList: {
      type: Array,
      default: () => ([])
    },
    title: {
      type: Boolean,
      default: true
    },
    oldForm: {
      type: Object,
      default: () => ({})
    },
    isEndorsement:{
      type: Boolean,
      default: false
    },
    showCompany:{
      type: Boolean,
      default: false
    },
    isQuote:{
      type: Boolean,
      default: false
    }
  },

  computed: {
    isEasyGo(){
      let {plan_type} = this.formData||{}
      return plan_type == 5
    },
    pcy_end_dt() {
      const { period_of_cvr, pcy_cmnt_dt } = this.formData
      if(pcy_cmnt_dt && period_of_cvr) {
        return dayjs(pcy_cmnt_dt).add(period_of_cvr, 'years').format('YYYY-MM-DD')
      }
      return ''
    },
    nm_traveler_list(){
      let data =  {
        rel:'',
        title:'',
        id_type:1,
        id_no:'',
        dob:'',
        dob_date:'',
        lst_nm:'',
        fst_nm:'',
        id_type_pic_path_id: '',
        id_type_pic_path: '',
        id_type_pic_url: '',
        id_type_pic_thumb_url:'',
        client_name: ''
      }
      let nm_traveler= []
      let obj = JSON.parse(JSON.stringify(data))
      let {no_of_traveler,nm_traveler_list=[],no_of_adult,no_of_child,class_type}=this.formData||{}
      let travel_no = no_of_traveler
      if(class_type==3){
        travel_no =  no_of_adult + no_of_child
      }
      if(nm_traveler_list.length<=0){
        for (var i= 0;i<travel_no;i++){
          nm_traveler.push(obj)
        }
      }else{
        nm_traveler = nm_traveler_list
      }
      return nm_traveler
    },
    old_traveler_list(){
      let {no_of_traveler,nm_traveler_list=[]}=this.oldForm||{}
      return nm_traveler_list
    },
    compareData() {
      let {benefits=[],student_info={},acc_parent_info={},class_type,quote_coverage_list,plan_type,destination,destination_id} = this.formData||{}
      let hasAcc = benefits.includes(2)
      student_info = student_info||{}
      acc_parent_info = acc_parent_info||{}
      let benefitsList = this.allOptions23.benefits || []
      let arr =[]
      if(benefitsList.length > 0){
        arr = benefitsList.filter(item => {
          return benefits.includes(item.id)
        })
      }
      let oldArr =[]
      if(benefitsList.length > 0){
        let {benefits=[]} = this.oldForm
        oldArr = benefitsList.filter(item => {
          if(benefits.length>0)
            return benefits.includes(item.id)
        })
      }
      let isSingle = [1,3].includes(plan_type)
      let destiona = ''
      let oldDestiona = ''
      let arr_destination = destination_id.length>0?destination_id.split(','):[]
      let old_arr_destination = this.oldForm.destination_id?this.oldForm.destination_id.split(','):[]
      if(isSingle){
        arr_destination.forEach((item,index)=>{
          if(item)
          {
            if(index==0){
              destiona =this.getAllOptionName23('destinations',item)
            }else
              destiona =destiona+' , '+this.getAllOptionName23('destinations',item)
          }
        })
        old_arr_destination.forEach((item,index)=>{
          if(index==0){
            oldDestiona =this.getAllOptionName23('destinations',item)
          }else
            oldDestiona =destiona+' , '+this.getAllOptionName23('destinations',item)
        })

      }
      let travelNumberList = [
        {
          name: 'Number of Senior',
          field:'no_of_senior',
          value:this.formData.no_of_senior,
          oldValue:this.oldForm.no_of_senior
        },
        {
          name: 'Number of Adult',
          field:'no_of_adult',
          fieldCode:'adult_num',
          option:23
        },
        {
          name: 'Number of Child',
          field:'no_of_child',
          fieldCode:'child_num',
          option:23
        }
      ]
      let detailList = [
        {
          name: 'Plan Type ',
          field: 'plan_type',
          fieldCode: 'plan_type',
          option:23
        },
        {
          name: 'Class Type',
          field: 'class_type',
          type: 'value',
          value:this.formData.class_type_language,
          oldValue:this.getAllOptionName23('class_type',this.oldForm.class_type),
          // option:10
        },
        {
          name: isSingle?'Main Destination (Must be HK Departures)':'Coverage',
          type: 'value',
          field: isSingle?'destination_id':'destination',
          value:isSingle?destiona:destination,
          oldValue:isSingle?oldDestiona:this.oldForm.destination,
        },
        {
          name: 'Expected Effective Date',
          field:'pcy_cmnt_dt',
          type: 'value',
          value:this.formData.is_eff_dt_delay&&this.isQuote?'ASAP':`${this.showHKTimeMin(this.formData.pcy_cmnt_dt)} ${this.formData.is_eff_dt_delay&&!this.isQuote?'(ASAP)':''}`,
          oldValue:this.showHKTime(this.formData.pcy_cmnt_dt),
        },
        {
          name: 'Expected Expiry Date',
          field:'pcy_expry_dt',
          is_time:true,
          is_end:true
        },
        {
          name: 'No. of Traveller(s)',
          field:'no_of_traveler',
          fieldCode:'traveler_num',
          option:23
        },
        ...travelNumberList,
        {
          name: 'Optional Benefits',
          field: 'benefits',
          type:'array',
          value:arr.length>0?arr:'',
          oldValue:oldArr.length>0?oldArr:''
        },
        {
          name: 'Insurer',
          field: 'company_language',
          notShow:!this.showCompany
        },
      ]

      // if(class_type!=1)
      //   detailList = [...detailList,...travelNumberList]
      let list = [
        {
          title: '',
          class: 'mg-b-10',
          list:detailList
        },
        {
          title: 'Policyholder Detail',
          isCompare: false,
          isBold: true,
          hasType:false,
          list: [
            {
              name: 'Title',
              field: 'isrd_title',
              fieldCode: 'titleOptions',
              option: 1
            }, {
              name: 'Last Name',
              field: 'isrd_lst_nm',

            }, {
              name: 'First Name',
              field: 'isrd_fst_nm'
            }, {
              name: 'Date of Birth',
              field: 'isrd_dob',
              is_birth:true
            }, {
              name: this.formData.id_type==1?'HKID':'Passport',
              field: 'id_no'
            }, {
              name: 'Nationality',
              field: 'id_nationality_seq_language',
              notShow: this.formData.id_type == 1
            },{
              name: 'Mobile Number',
              field: 'mobile_no',

            },
            {
              name: 'Email',
              field: 'email',
            },
            {
              name: 'Occupation',
              field: 'occ',
              notShow: this.formData.plan_type !=2
            },
            {
              name: 'Policyholder is one of the traveller?',
              field:'hldr_is_traveler_ind',
              fieldCode:'yesNoOptions',
              option:1,
              notShow: this.formData.plan_type == 2
              // fieldCode: 'occupation',
              // option: 26,
            },
          ],
        },

      ]
      let address_add = [
        {
          title: 'Correspondence Address',
          isBold: false,
          list: [
            {
              name: 'Room',
              field: 'addr_room'
            }, {
              name: 'Floor',
              field: 'addr_floor'
            }, {
              name: 'Block',
              field: 'addr_block'
            }, {
              name: 'Building / Estate',
              field: 'addr_building'
            }, {
              name: 'Street',
              field: 'addr_street'
            }, {
              name: 'District',
              field: 'addr_district',
              addressCode: 'district',
              isAddress: true
            }, {
              name: 'Area',
              field: 'addr_area',
              addressCode: 'area',
              isAddress: true
            }, {
              name: 'Country / Region',
              field: 'addr_region',
              isAddress: true,
              addressCode: 'region'
            },
          ]
        },
      ]
      return this.isEasyGo?list:list.concat(address_add)
    },
    travelCompare(){
      return{

      }
    },
    compareChange(){
      return (index,name)=>{
        let {type} = this.form||{}
        let list = this.nm_traveler_list||[]
        let pre = this.oldForm||{}
        let preList =pre.nm_traveler_list||[]
        // if(type!=50)return  false
        if(!this.isEndorsement)return  false
        if(preList.length<=0)return false
        return list[index][name]!=preList[index][name]||false
      }
    },
    oldTravle(){
      return (index,name)=>{
        let pre = this.oldForm||{}
        let preList =pre.nm_traveler_list||[]
        if(preList.length<=0)return {}
        return preList[index][name]
      }
    }
  },
  methods:{
    handleCompare(filed){
      let {type} = this.formData
      if(type!=50) return false
      return  this.compareList.includes(filed)?true:false
    },
    openFile(url) {
      if(url) {
        window.open(url, '_blank')
      }
    },
    showCompare(item, field,sunF) {
      var change = field
      if (item.option) {
        switch (item.option) {
          case 1:
            change = this.getOptionName(item.fieldCode, field)
            break
          case 23:
            change = this.getAllOptionName23(item.fieldCode, field)
            break
        }
      }
      if (item.isAddress) {
        change = this.getAreaName(item.addressCode, field)
      }
      if (item.is_birth) {
        change = this.showHKDate(field)
      }
      if (item.is_time) {
        change = this.showHKTimeMin(field,item.is_end)
      }
      return change
    },
  }
}
</script>
<style lang="scss" scoped>
.quote-info {
  .box {
    margin-bottom: 15px;
  }
  .mg-b-0 {
    margin-bottom: 0!important;
  }

  .title {
    display: block;
    padding: 15px 0;
    font-size: 16px;
    font-weight: 400;
    color: #616266;
  }

  .table {
    .tr {
      .compare {
        display: flex;
        align-items: center;

        & > span {
          flex: 1;
        }
      }
    }
  }
  .asap{
    font-weight: bold;
    color: black;
    margin-left: 5px;
  }
}
</style>
